import React from "react";
import styles from "./newUserPopup.module.css";
import store from "../../../Store/Store";
import { useNavigate } from "react-router-dom";
import config from "../../../config/config";
import axios from "axios";

export default function NewUserPopup({
  title,
  message,
  linkText,
  onLinkClick, // optional: handle routing
  href = "#", // optional: fallback link
  className = "",
  advKycStatus,
  whitelistingStatus,
  setShowBanner,
  onboardingStatus,
  showOthers
}) {
  const id = "bank-connect-banner";
  const navigate = useNavigate();
  const LinkEl = (
    <a
      className={styles.link}
      href={"/content/kycValidation?tab=2"}
      onClick={(e) => {
        if (onLinkClick) {
          e.preventDefault();
          onLinkClick();
        }
      }}
    >
      {"See how to whitelist your account."}
    </a>
  );
console.log("advKycStatus",advKycStatus);
console.log("whitelistingStatus",whitelistingStatus);
console.log("onboardingStatus",onboardingStatus);


  const handleCloseBanner = async () => {
    console.log("Hello WOrld");

    try {
      let tokens = localStorage.getItem("authToken");
      let parsedTokens = JSON.parse(tokens);
      await axios.post(
        `${config.kyc_api_endpoint}/status-update`,
        {
          status: "DONE",
          ledger_label: store.Company_Id, // from context or props
        },
        {
          headers: {
            aws_cognito_id_token: parsedTokens.IdToken,
            aws_cognito_access_token: parsedTokens.AccessToken,
            "Content-Type": "application/json",
          },
        },
      );
      setShowBanner(true);
    } catch (err) {
      console.log("Failed to update onboarding status:", err);
    }
  };


  return (
    <>
      <div className={styles.divcenterContainer}>
        {whitelistingStatus === "pending" && (
          <div className={styles.divcenter}>
            <section
              className={`${styles.banner} ${className}`}
              role="region"
              aria-labelledby={id}
            >
              <div className={styles.headerRow}>
                <h3 id={id} className={styles.title}>
                  {"Transfer money to this Bank Account to use CUPI"}
                </h3>
              </div>

              <p className={styles.desc}>
                {`Transfer money only from `}
                <span className={styles.Bold}>{store.companyName}</span> /{" "}
                <span className={styles.Bold}>{store.tradeName}</span> Bank
                Account.
                {/* {LinkEl} */}
              </p>
              <button
                className={styles.ButtonToAccountWhiteList}
                onClick={() => {
                  navigate("/content/kycValidation?tab=2");
                }}
              >
                How to load money? Click here
              </button>
            </section>
          </div>
        )}
        {advKycStatus === "pending" &&showOthers&& (
          <div className={styles.divcenter}>
            <section
              className={`${styles.banner} ${className}`}
              role="region"
              aria-labelledby={id}
            >
              <div className={styles.inlineCtaRow}>
                <h3 id={id} className={styles.title}>
                  {"Complete your Company KYC "}
                </h3>
                {/* <button
                  type="button"
                  className={styles.primaryBtn}
                  onClick={() => {
                    navigate("/content/kycValidation?tab=1");
                  }}
                >
                  Continue
                </button> */}
              </div>

              <p className={styles.desc}>
                With Basic KYC, your spending limit is{" "}
                <span className={styles.Bold}>₹1,00,000</span> in total.
                Complete Advanced KYC to unlock unlimited spending.
              </p>
              <button
                type="button"
                className={styles.ButtonToAccountWhiteList}
                onClick={() => {
                  navigate("/content/kycValidation?tab=1");
                }}
              >
                Continue
                <img
                  className={styles.vectorIcon}
                  alt=""
                  src="/arrow-narrow-right.svg"
                />
              </button>
            </section>
          </div>
        )}
        {onboardingStatus !== "DONE" &&
          advKycStatus === "completed" &&
          whitelistingStatus === "completed" &&showOthers&& (
            <div className={styles.divcenter}>
              <section
                className={`${styles.banner2} ${className}`}
                role="region"
                aria-labelledby={id}
              >
                {/* ✅ close button */}
                <button
                  type="button"
                  className={styles.closeBtn}
                  aria-label="Close"
                  onClick={() => {
                    handleCloseBanner();
                  }} // or your own handler
                >
                  ×
                </button>

                <div className={styles.row}>
                  <img
                    src="/kycDone.svg"
                    alt="KYC Done"
                    className={styles.image}
                  />

                  <div className={styles.content}>
                    <h3 id={id} className={styles.title}>
                      KYC and Bank account validation done!
                    </h3>
                    <p className={styles.desc1}>
                      See your KYC and validated Bank Account details in the
                      Profile section.
                    </p>
                  </div>
                </div>
              </section>
            </div>
          )}
      </div>
    </>
  );
}
